import { ArrowRight, CheckCircle2 } from "lucide-react";
import { NEWS_COLORS } from "../constants/news.constants";
import {
  delhiArticle,
  delhiHighlights,
} from "../data/newsContent";
import { NewsHighlightGrid } from "./NewsHighlightGrid";
import { NewsMeta, NewsTag } from "./NewsTag";
import { NewsVideoCard } from "./NewsVideoCard";

export function NewsArticleDelhi() {
  const a = delhiArticle;

  return (
    <article id={a.id} className="scroll-mt-24 mt-12 sm:mt-16 border-t border-gray-100 pt-12 sm:pt-16">
      <div className="grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-start lg:gap-10">
        <div>
          <div className="flex flex-wrap items-center gap-3">
            <NewsTag>{a.tag}</NewsTag>
            <NewsMeta date={a.date} readTime={a.readTime} />
          </div>
          <h2 className="mt-4 text-2xl font-extrabold leading-snug tracking-tight text-gray-900 sm:text-3xl">
            {a.title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-gray-600 sm:text-base">
            {a.description}
          </p>
          <ul className="mt-5 space-y-2.5">
            {a.keyPoints.map((point) => (
              <li key={point} className="flex items-start gap-2.5 text-sm text-gray-700">
                <CheckCircle2
                  className="mt-0.5 h-4 w-4 shrink-0"
                  style={{ color: NEWS_COLORS.primary }}
                  aria-hidden
                />
                <span>{point}</span>
              </li>
            ))}
          </ul>
          <a
            href={a.readMoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 rounded-full border-2 px-5 py-2.5 text-sm font-semibold transition-colors hover:bg-[#E8F5F0]"
            style={{
              borderColor: NEWS_COLORS.primary,
              color: NEWS_COLORS.primary,
            }}
          >
            Read More
            <ArrowRight className="h-4 w-4" aria-hidden />
          </a>
        </div>

        <NewsVideoCard
          label={a.videoLabel}
          duration={a.videoDuration}
          tone="city"
        />
      </div>

      <NewsHighlightGrid items={delhiHighlights} />
    </article>
  );
}
